import Standard from './models/Standard'
import { createStandard, loadStandard, updateStandard, loadStandardsList } from '@/api/super'

let standardModel = new Standard

export default {

  namespaced: true,

  state: {
    standard: standardModel,
    standards_list: []
  },

  mutations: {
    ...standardModel.mutations(),
    setList: (state, payload) => state.standards_list = payload
  },

  actions: {
    store: ({ state }) => new Promise((resolve, reject) => createStandard(state.standard, resolve, reject)),
    update: ({ state }) => new Promise((resolve, reject) => updateStandard(state.standard, resolve, reject)),
    loadStandard: ({ commit }, standardId) => new Promise((resolve, reject) => loadStandard(standardId, ({ data }) => {
      commit('setStandard', data)
      resolve()
    }, reject)),
    loadStandardsList: ({ commit }) => new Promise((resolve, reject) => {
      loadStandardsList(({ data }) => {
        commit('setList', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    standard: state => state.standard,
    standardsList: state => state.standards_list,
  }

}